import { createSlice } from "@reduxjs/toolkit";
import { pagination } from "../../../type/pagination";
import {
  langMap,
  notification,
} from "../../../type/admins/notifications-lists";

export const notificationsLists = createSlice({
  name: "all-notifications",
  initialState: {
    value: {
      status: false,
      pagination: [] as {
        pagination_data: pagination;
        data: notification[];
      }[],
      data: [] as notification[],
      langMap: [
        {
          langCode: "en",
          title: "",
          summary: "",
          mainContent: [
            {
              id: "first-item",
              text: "",
              image: [],
            },
          ],
        },
      ] as langMap[],
    },
    // selectedUsers: [],
    selectedUsers: [] as string[], 
  },
  reducers: {
    updateNotificationsList: (state, action) => {
      state.value.status = true;
      state.value.data = action?.payload?.data;
    },
    updateNotificationLangMap: (state, action) => {
      state.value.langMap = action?.payload?.data;
    },
    addNotificationLang: (state, action) => {
      const { langCode } = action?.payload;
      const currentState = state.value.langMap;
      const findIndex = currentState.findIndex(
        (item) => item?.langCode === langCode
      );
      if (findIndex !== -1) {
        state.value.langMap[findIndex] = action?.payload;
      } else {
        state.value.langMap.push(action?.payload);
      }
    },
    addNotificationsToList: (state, action) => {
      state.value.data = [...state.value.data, action?.payload];
      //include in pagination data
      const pagination_data = [...state.value.pagination];
      const lastIndex = pagination_data?.length - 1;
      const addedItem = pagination_data.map((item, index) => {
        if (lastIndex === index) {
          return {
            pagination_data: item?.pagination_data,
            data: [...item.data, action?.payload],
          };
        } else {
          return item;
        }
      });
      state.value.pagination = addedItem;
    },
    addToPaginationHistory: (state, action) => {
      const found = state.value?.pagination?.find(
        (item) =>
          item?.pagination_data?.current_page ===
          action?.payload?.pagination_data?.current_page
      );
      if (!found) {
        state.value.pagination = [
          ...state.value.pagination,
          {
            pagination_data: action?.payload?.pagination_data,
            data: action?.payload?.data,
          },
        ];
      }
    },
    removeNotificationsInList: (state, action) => {
      const { _id } = action?.payload;
      const currentArray = [...state.value.data];
      const currentIndex = currentArray.findIndex(
        (v: { _id: string }) => v._id === _id
      );
      if (currentIndex >= 0) {
        currentArray.splice(currentIndex, 1);
        state.value.data = currentArray;
      }
      //remove from paginated data
      const pagination_data = [...state.value.pagination];
      const removed = pagination_data.map((item, index) => {
        const sencondFilter = item.data.filter((data, i) => {
          return !data._id === _id;
        });
        return {
          pagination_data: { ...item.pagination_data },
          data: sencondFilter,
        };
      });
      state.value.pagination = removed;
    },
    replaceNotificationsInList: (state, action) => {
      const { _id } = action?.payload;
      const currentArray = state.value.data;
      const currentIndex = currentArray.findIndex(
        (v: { _id: string }) => v._id === _id
      );
      if (currentIndex >= 0) {
        currentArray.splice(currentIndex, 1, action?.payload);
        state.value.data = currentArray;
      }
      //REPLACE pagination data
      const pagination_data = [...state.value.pagination];
      const replacedItem = pagination_data.map((item, index) => {
        const sencondFilter = item.data.map((data, i) => {
          if (data._id === _id) {
            return { ...action.payload };
          } else {
            return data;
          }
        });
        return {
          pagination_data: { ...item.pagination_data },
          data: sencondFilter,
        };
      });
      state.value.pagination = replacedItem;
    },
    addSelectedUser: (state, action) => {
      if (!state.selectedUsers.includes(action.payload)) {
        state.selectedUsers.push(action.payload);
      }
    },
    removeSelectedUser: (state, action) => {
      state.selectedUsers = state.selectedUsers.filter(
        (id) => id !== action.payload
      );
    },
    clearSelectedUsers: (state) => {
      state.selectedUsers = [];
    },
    clearPagination: (state) => {
      state.value.pagination = [];
    },
    clearNotificationsList: (state) => {
      state.value.status = false;
      state.value.data = [];
    },
  },
});

export const {
  updateNotificationsList,
  addNotificationsToList,
  addToPaginationHistory,
  removeNotificationsInList,
  replaceNotificationsInList,
  addNotificationLang,
  updateNotificationLangMap,
  clearNotificationsList,
  removeSelectedUser,
  addSelectedUser,
  clearSelectedUsers,
  clearPagination
} = notificationsLists.actions;

export default notificationsLists.reducer;
